import { ChevronDown, FileText } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { TipoDocumento } from './GestaoDocumentosTable';
import type { FiltroBase } from '@/contexts';
import type { SimplesNacionalGrupo } from '@/services/SimplesNacional/GestaoDocumentos/api/ListaDocumentosSimplesApi';
import { useGrupoDocumentos, ITENS_POR_PAGINA, Pagination } from '../GestaoDocumentosProvider';
import { GestaoDocumentosTable } from './GestaoDocumentosTable';

interface Props {
  grupo: SimplesNacionalGrupo;
  tipo: TipoDocumento;
  filtroBase: FiltroBase;
}

export function GrupoDocumentosSection({ grupo, tipo, filtroBase }: Props) {
  const {
    isOpen,
    setIsOpen,
    currentPage,
    handlePageChange,
    documentos,
    isPageLoading,
    totalPaginas,
    nomeModelo,
  } = useGrupoDocumentos(grupo, filtroBase);

  return (
    <div className="rounded-lg border bg-card shadow-sm overflow-hidden">
      <button
        type="button"
        className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-muted/30 transition-colors"
        onClick={() => setIsOpen(v => !v)}
        aria-expanded={isOpen}
      >
        <FileText
          className={cn(
            'h-4 w-4 shrink-0',
            tipo === 'entradas' ? 'text-green-600' : 'text-red-600'
          )}
        />
        <span className="font-medium text-sm">
          {nomeModelo} (Modelo {grupo.codigoModelo})
        </span>
        <span className="inline-flex items-center rounded-full bg-[#aed561]/15 px-2 py-0.5 text-xs font-medium text-[#5a7a1a]">
          {grupo.totalItens.toLocaleString('pt-BR')} documento(s)
        </span>
        <span className="ml-auto flex items-center gap-2">
          <span
            className={cn(
              'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium',
              tipo === 'entradas'
                ? 'border-green-500 text-green-700'
                : 'border-red-500 text-red-700'
            )}
          >
            {tipo === 'entradas' ? 'Crédito' : 'Débito'}
          </span>
          <ChevronDown
            className={cn(
              'h-4 w-4 text-muted-foreground transition-transform duration-200',
              isOpen && 'rotate-180'
            )}
          />
        </span>
      </button>

      {isOpen && (
        <div className="border-t">
          <GestaoDocumentosTable tipo={tipo} documentos={documentos} isLoading={isPageLoading} />
          {totalPaginas > 1 && (
            <div className="flex items-center justify-between px-4 py-3 border-t bg-muted/20">
              <span className="text-xs text-muted-foreground">
                {ITENS_POR_PAGINA} itens por página
              </span>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPaginas}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
